<template>
  <a-form :form="form" class="login-form" @submit="handleSubmit">
    <a-card class="login-card">
      <template slot="title">
        <div>
          <img id="imgLogo" src="../assets/GlsLogo.png" />
          <h4>Sign in to Subscription</h4>
        </div>
      </template>
      <a-form-item>
        <a-input
          size="large"
          autocomplete="username"
          v-decorator="[
            'username',
            {
              rules: [
                { required: true, message: 'Please input your username!' },
              ],
            },
          ]"
          placeholder="Username"
        >
          <a-icon slot="prefix" type="user" class="input-icon" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input
          size="large"
          autocomplete="current-password"
          v-decorator="[
            'password',
            {
              rules: [
                { required: true, message: 'Please input your Password!' },
              ],
            },
          ]"
          type="password"
          placeholder="Password"
        >
          <a-icon slot="prefix" type="lock" class="input-icon" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-checkbox
          v-decorator="[
            'remember',
            {
              valuePropName: 'checked',
              initialValue: true,
            },
          ]"
        >
          Remember me
        </a-checkbox>
        <!-- <a class="login-form-forgot" href=""> Forgot password </a> -->
        <a-button
          size="large"
          type="primary"
          html-type="submit"
          :loading="isLoading"
          class="login-form-button"
        >
          Log in
        </a-button>
        <!-- Or
      <a href=""> register now! </a> -->
      </a-form-item>
    </a-card>
  </a-form>
</template>

<script>
export default {
  data() {
    return {
      user: {},
      isLoading: false,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.isLoading = true;

          try {
            await this.$loginUser(values);
          } catch (error) {
            this.$message.error(
              error.response?.data?.errors[0]?.message ?? error.message
            );
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-form {
  $phone: 640px;
  $tablet: 768px;
  $desktop: 1024px;

  min-width: 100vw;
  min-height: 100vh;

  .login-card {
    width: 450px;
    position: absolute;
    right: 25%;
    top: calc(100vh / 5);

    @media screen and (max-width: $phone) {
      width: 85%;
      position: fixed;
      right: unset;
    }

    @media screen and (min-width: $phone) and (max-width: $tablet) {
      position: absolute;
      right: 20%;
    }
  }
  #imgLogo {
    width: 249px;
    height: 118px;
    padding: 0px;
  }

  .input-icon {
    color: rgba(0, 0, 0, 0.25);
  }

  .login-form-forgot {
    float: right;
  }

  .login-form-button {
    width: 100%;
    margin: 10px auto;
  }
}
</style>
